import { PageType } from '@/types';
import { MIXPANEL_EVENT, type MixpanelEvent } from './events';

/*
    This file contains helper functions to get Mixpanel event names based on the pageType
    In hindsight perhaps event names should be generic to avoid the need for these. 
    I opted for a trade off to do it this way so that event names were more human readable for PM's and non techies.
    Miles Tuffs :'(
*/

// Campaign Table 
export function getCampaignsTableFilterClickedEventByPageType(pageType: PageType): MixpanelEvent { 
    return pageType === 'earnings' ? MIXPANEL_EVENT.earnings.campaignsTable.filterClicked : MIXPANEL_EVENT.payouts.campaignsTable.filterClicked;
}

export function getCampaignsTableFilterOptionClickedEventByPageType(pageType: PageType): MixpanelEvent { 
    return pageType === 'earnings' ? MIXPANEL_EVENT.earnings.campaignsTable.filterOptionClicked : MIXPANEL_EVENT.payouts.campaignsTable.filterOptionClicked;
}
export function getCampaignsTablePaginateClickedEventByPageType(pageType: PageType): MixpanelEvent { 
    return pageType === 'earnings' ? MIXPANEL_EVENT.earnings.campaignsTable.paginateClicked : MIXPANEL_EVENT.payouts.campaignsTable.paginateClicked;
}

// Campaign Types Chart
export function getCampaignTypesBarChartHoverEventByPageType(pageType: PageType): MixpanelEvent { 
    return pageType === 'earnings' ? MIXPANEL_EVENT.earnings.campaignTypes.barChartHover : MIXPANEL_EVENT.payouts.campaignTypes.barChartHover;
}

export function getCampaignTypesDownloadClickedEventByPageType(pageType: PageType): MixpanelEvent { 
    return pageType === 'earnings' ? MIXPANEL_EVENT.earnings.campaignTypes.downloadClicked : MIXPANEL_EVENT.payouts.campaignTypes.downloadClicked;
}

// Shows filter
export function getShowsFilterOpenedEventByPageType(pageType: PageType): MixpanelEvent {
  if (pageType === 'audience') {
    return MIXPANEL_EVENT.audience.showsFilter.opened;
  }
  if (pageType === 'content-performance') {
    return MIXPANEL_EVENT.contentPerformance.showsFilter.opened;
  }
  return MIXPANEL_EVENT.earnings.showsFilter.opened;
}

export function getShowsFilterSelectedEventByPageType(pageType: PageType): MixpanelEvent {
  if (pageType === 'audience') {
    return MIXPANEL_EVENT.audience.showsFilter.selected;
  }
  if (pageType === 'content-performance') {
    return MIXPANEL_EVENT.contentPerformance.showsFilter.selected;
  }
  return MIXPANEL_EVENT.earnings.showsFilter.selected;
}

// Date Picker
export function getDatePickerOpenedEventByPageType(pageType: PageType): MixpanelEvent {
  if (pageType === 'audience') {
    return MIXPANEL_EVENT.audience.date.opened;
  }
  if (pageType === 'content-performance') {
    return MIXPANEL_EVENT.contentPerformance.date.opened;
  }
  return MIXPANEL_EVENT.earnings.date.opened;
}

export function getDatePresetSelectedEventByPageType(pageType: PageType): MixpanelEvent {
  if (pageType === 'audience') {
    return MIXPANEL_EVENT.audience.date.presetSelected;
  }
  if (pageType === 'content-performance') {
    return MIXPANEL_EVENT.contentPerformance.date.presetSelected;
  }
  return MIXPANEL_EVENT.earnings.date.presetSelected;
}

export function getDateAppliedEventByPageType(pageType: PageType): MixpanelEvent {
  if (pageType === 'audience') {
    return MIXPANEL_EVENT.audience.date.applied;
  }
  if (pageType === 'content-performance') {
    return MIXPANEL_EVENT.contentPerformance.date.applied;
  }
  return MIXPANEL_EVENT.earnings.date.applied;
}
